import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";

const taskname = "claimrewards";

export default function(props) {
  const { accountdetailrow } = props;

  return (
    <TaskDialog heading={"Claim Rewards from event center"}>
      <RunButton
        taskname={taskname}
        taskConfig={{
          accountdetail: accountdetailrow,
        }}
        label={"Claim Rewards"}
      />
    </TaskDialog>
  );
}
